import React from "react";
import { styled } from "@mui/system";
const ErrorElement = styled("div")(({ theme }) => {
    return {
        flexDireaction: "column",
        color: "red",
        fontWeight: 400,
        display: "flex",
        justifyContent: "center",
        marginBottom: 20,
        animation: "hideMe 1s forwards",
        fontSize: "1.6vw",
        span: {
            padding: "1.2vw 4vw",
            border: "1px solid #e9716f",
            width: "74.5vw",
        },
        "@keyframes hideMe": {
            "0%": {
                opacity: 0,
            },
            "100%": {
                opacity: 1,
            },
        },
    };
});
export const ErrorMessage = ({ error }) => {
    if (!error)
        return null;
    return (React.createElement(ErrorElement, { className: "error-message" },
        React.createElement("span", null, error)));
};
